import useSWR from "swr";


import { VersionList } from "./version-card";
import type { Version } from "@/types/domain";

const AuditVersions = () => {
  const { data: versions, isLoading } = useSWR<Version[]>([
    "/versions/audits",
  ]);

  const list: Version[] = versions ?? [];

  return (
    <div className="flex flex-col gap-4">
      <VersionList versions={list} isLoading={isLoading} />
    </div>
  );
};

export default AuditVersions;
